/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Grow_With_EbInputs */

const en_admin_dashboard_grow_with_eb = /** @type {(inputs: Admin_Dashboard_Grow_With_EbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grow with external bookings`)
};

const de_admin_dashboard_grow_with_eb = /** @type {(inputs: Admin_Dashboard_Grow_With_EbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr mit externen Buchungen`)
};

const es_admin_dashboard_grow_with_eb = /** @type {(inputs: Admin_Dashboard_Grow_With_EbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más con reservas externas`)
};

const fr_admin_dashboard_grow_with_eb = /** @type {(inputs: Admin_Dashboard_Grow_With_EbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus avec réservations externes`)
};

const nl_admin_dashboard_grow_with_eb = /** @type {(inputs: Admin_Dashboard_Grow_With_EbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groei met externe reserveringen`)
};

const it_admin_dashboard_grow_with_eb = /** @type {(inputs: Admin_Dashboard_Grow_With_EbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cresci con le prenotazioni esterne`)
};

const pt_br2_admin_dashboard_grow_with_eb = /** @type {(inputs: Admin_Dashboard_Grow_With_EbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cresça com reservas externas`)
};

const pl_admin_dashboard_grow_with_eb = /** @type {(inputs: Admin_Dashboard_Grow_With_EbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozwijaj się dzięki rezerwacjom zewnętrznym`)
};

const hu_admin_dashboard_grow_with_eb = /** @type {(inputs: Admin_Dashboard_Grow_With_EbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Növekedés külső foglalásokkal`)
};

const ro_admin_dashboard_grow_with_eb = /** @type {(inputs: Admin_Dashboard_Grow_With_EbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cresteti cu rezervari externe`)
};

/**
* | output |
* | --- |
* | "Grow with external bookings" |
*
* @param {Admin_Dashboard_Grow_With_EbInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_grow_with_eb = /** @type {((inputs?: Admin_Dashboard_Grow_With_EbInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Grow_With_EbInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_grow_with_eb(inputs)
	if (locale === "de") return de_admin_dashboard_grow_with_eb(inputs)
	if (locale === "es") return es_admin_dashboard_grow_with_eb(inputs)
	if (locale === "fr") return fr_admin_dashboard_grow_with_eb(inputs)
	if (locale === "nl") return nl_admin_dashboard_grow_with_eb(inputs)
	if (locale === "it") return it_admin_dashboard_grow_with_eb(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_grow_with_eb(inputs)
	if (locale === "pl") return pl_admin_dashboard_grow_with_eb(inputs)
	if (locale === "hu") return hu_admin_dashboard_grow_with_eb(inputs)
	return ro_admin_dashboard_grow_with_eb(inputs)
});
export { admin_dashboard_grow_with_eb as "admin.dashboard.grow_with_eb" }